import { B2B_PACKAGE_TYPE } from "../../../data/static-data"
import { validateReceiver } from "../../../validators/validateReceiver"
import { validators } from "../../../validators/validators"

export const validateBlock = (num, state, errors) => {
    if(num === 1) {
        return validateFirstBlock(state)
    }
    if(num === 2) {
        return validateSecondBlock(state)
    }

    return [true, []]
}

const validateFirstBlock = (state) => {
    let flag = true
    let errors = [];

    if(state["declared-price"] && validators.ValidateNumber(state["declared-price"])) {
       errors.push("Неверная объявленная стоимость") 
       flag = false
    }

    if (state["package-type"] === B2B_PACKAGE_TYPE) {
        if(!state["B2B-order-type"]) {
            errors.push("Выберите тип оформления B2B")
            flag = false
        }

        // if(validators.ValidateNumber(state["B2B-order-number"])) {
        //     errors.push("Номер оформления B2B должен быть числом")
        //     flag = false
        // }
    }

    return [flag, errors]
}

const validateSecondBlock = (state) => {
    let flag = true
    let errors = []

    let res = validateReceiver(state)
    if(state.countryHasCities && !state["receiver-city"]) {
        res.push("shipments.create_shipment.receiver.select_city.errors.required")
    }
    if(res !== null && res.length > 0) {
        errors = res
        flag = false
    }

    return [flag, errors]
}